import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  private loadingMap = new Map<string, BehaviorSubject<boolean>>();

  constructor(public http: HttpClient) {}

  getLoading(loader?: string): boolean {
    if (!loader) return false;
    if (!this.loadingMap.has(loader)) {
      this.loadingMap.set(loader, new BehaviorSubject<boolean>(false));
    }
    return this.loadingMap.get(loader)!.getValue();
  }

  setLoading(loader?: string, isLoading: boolean = false): void {
    if (!loader) return;
    if (!this.loadingMap.has(loader)) {
      this.loadingMap.set(loader, new BehaviorSubject<boolean>(false));
    }
    this.loadingMap.get(loader)!.next(isLoading);
  }

  list(apiUrl: string, options?: any, loader?: string): Observable<any> {
    if (loader) this.setLoading(loader, true);

    return new Observable((observer) => {
      this.http.get(apiUrl, options).subscribe(
        (response) => {
          observer.next(response);
        },
        (error) => {
          observer.error(error);
        },
        () => {
          if (loader) this.setLoading(loader, false);
        },
      );
    });
  }

  action(apiUrl: string, data: any, loader?: string): Observable<any> {
    if (loader) this.setLoading(loader, true);

    return this.http.post(apiUrl, data).pipe(
      tap({
        next: (res: any) => res,
        error: (err: any) => err,
        finalize: () => loader && this.setLoading(loader, false),
      }),
    );
  }
}
